import { Typography } from '@mui/material';
import {
  CustomTable,
  CustomTableContainer,
} from '@components/Styles/TableStyle';
import {
  RequiredMark,
  RequiredMarkBox,
  SectionWrapper,
} from '@components/Styles/CommonStyle';
import React, { useState } from 'react';
import { TableBody } from '@mui/material';
import { CustomStack } from '@components/Styles/CommonStyle';
import CompanyAccountCreateTableName from './CompanyAccountCreateTableName';
import CompanyAccountCreateTablePhone from './CompanyAccountCreateTablePhone';
import CompanyAccountCreateTableRepresent from './CompanyAccountCreateTableRepresent';
import CompanyAccountCreateTableAddress from './CompanyAccountCreateTableAddress';
import CompanyAccountCreateTableLicense from './CompanyAccountCreateTableLicense';
import CompanyAccountCreateTableEmail from './CompanyAccountCreateTableEmail';
import { theme } from '@components/Styles/theme';

const CompanyAccountCreateTable = ({ param, setParam, contactList, setContactList, contactParam, setContactParam }) => {
  // 우편번호 찾기 모달
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // 우편번호 찾기
  const handleComplete = (data) => {
    setParam({ ...param, zonecode: data.zonecode, address: data.address });
    handleClose();
  };

  // 파일 찾기
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    // 사업자등록증
    if (event.target.name === 'businessLicenseFile') {
      setParam({ ...param, businessLicenseFile: file });
    }
    // 통장사본
    else if (event.target.name === 'bankbookFile') {
      setParam({ ...param, bankbookFile: file });
    }
  };


  return (
    <React.Fragment>
      <CustomStack mb={2}>
        <Typography sx={theme.typography.h4}>법인 사업자 등록</Typography>
      </CustomStack>
      <SectionWrapper>
        <CustomStack justifyContent="spaceBetween" mb={2}>
          <Typography sx={theme.typography.h4}>사업자 정보</Typography>
          <RequiredMarkBox>
            <RequiredMark />
            (&nbsp;&nbsp;) 필수입력사항
          </RequiredMarkBox>
        </CustomStack>
        <CustomTableContainer>
          <CustomTable fourColumn>
            <TableBody>
              
              <CompanyAccountCreateTableName param={param} setParam={setParam}></CompanyAccountCreateTableName>        

              <CompanyAccountCreateTableRepresent param={param} setParam={setParam}></CompanyAccountCreateTableRepresent>
              
              <CompanyAccountCreateTableAddress param={param} handleOpen={handleOpen} handleClose={handleClose} handleComplete={handleComplete} setParam={setParam} open={open}></CompanyAccountCreateTableAddress>
              
              <CompanyAccountCreateTableLicense param={param} handleFileChange={handleFileChange}></CompanyAccountCreateTableLicense>

              <CompanyAccountCreateTableEmail param={param} setParam={setParam}></CompanyAccountCreateTableEmail>

            </TableBody>
          </CustomTable>
        </CustomTableContainer>
      </SectionWrapper>

      <SectionWrapper>
        <CompanyAccountCreateTablePhone 
        contactList={contactList}
        setContactList={setContactList}
        contactParam={contactParam}
        setContactParam={setContactParam}
       />
      </SectionWrapper>
    </React.Fragment>
  );
};

export default CompanyAccountCreateTable;

